import { useLayoutEffect } from 'react';
import type { Checkpoint, Exercise, Lesson } from '@pen/shared';
import { PracticeWorkspace } from '../practice/PracticeWorkspace';

export function PracticeLayer(props: { lesson: Lesson; checkpoint: Checkpoint; exercise?: Exercise | null; reviewId: string | null; onDone(result: 'correct' | 'partial' | 'open'): void; onClose(): void; onNext?(exercise: Exercise): void }) {
  useLayoutEffect(() => {
    const y = window.scrollY;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; window.scrollTo(0, y); };
  }, []);
  return <div className="practice-layer" role="dialog" aria-modal="true" aria-label={props.checkpoint.title}><PracticeWorkspace {...props} /></div>;
}
